import { Button, H4 } from '@shared/react-ui-core';
import React from 'react';
import Imgix from 'react-imgix';
import s from './index.module.scss';

const EufyPartners: React.FC<{
  exclude?: (
    | 'outdoor-camera-eufy'
    | 'doorbell-camera-eufy'
    | 'indoor-camera-eufy'
    | string
  )[];
  ctaLink?: string;
}> = ({ exclude = [], ctaLink = '/quiz' }) => {
  const cameras = [
    {
      id: 'outdoor-camera-eufy',
      image: 'https://www.datocms-assets.com/10154/1697580946-eufy-s220-2.png',
      badge:
        'https://www.datocms-assets.com/10154/1714424920-eufy-outdoor-2-way-communication-badge.png',
      name: 'Eufy Outdoor Camera',
      link: '/products/outdoor-camera/',
      imgParams: { width: 246, height: 228 },
      description:
        'Designed to detect movement outside your home, this wireless camera is weatherproof and has a built-in solar panel to keep the battery charged.',
    },
    {
      id: 'doorbell-camera-eufy',
      image:
        'https://www.datocms-assets.com/10154/1691587879-eufy-doorbell-camera.png',
      badge:
        'https://www.datocms-assets.com/10154/1680797634-eufy-doorbell-camera-simple-install-badge.png',
      name: 'Eufy Doorbell Camera',
      link: '/products/doorbell-camera-eufy/',
      imgParams: { width: 246, height: 228 },
      description:
        'Talk to visitors and know when packages are delivered early with this easy-to-install wireless doorbell camera.',
    },
    {
      id: 'indoor-camera-eufy',
      image:
        'https://www.datocms-assets.com/10154/1691587891-eufy-indoor-camera-1.png',
      badge: 'https://www.datocms-assets.com/10154/1698255524-group-383.png',
      name: 'Eufy Indoor Camera',
      link: '/products/indoor-camera/',
      imgParams: { width: 246, height: 228 },
      description:
        "Always know what's happening at home with this discreet motion-and noise-activated camera.",
    },
  ];
  const filteredCameras = cameras.filter(
    (camera) => !exclude.includes(camera.id),
  );

  const loading = 'lazy';

  return (
    <>
      <div className={s.contentContainer}>
        <div className={s.wrapperEufyPartners}>
          <div className={s.copyWrapper}>
            <h3 className="text-h1" style={{ margin: '15px 0 25px' }}>
              Powerful protection from every angle.
            </h3>
            {filteredCameras.map((camera) => {
              return (
                <div className={s.cameraRow} key={camera.name}>
                  <b className="text-base">{camera.name}</b>
                  <p className="text-base">{camera.description}</p>
                </div>
              );
            })}
          </div>
          <div className={s.displayWrapper}>
            {filteredCameras.map((camera) => {
              const { image, badge, link, name, imgParams } = camera;
              return (
                <div
                  className={
                    !!exclude.length ? s.cameraWrapperExclude : s.cameraWrapper
                  }
                  key={badge}
                >
                  <Imgix
                    src={badge}
                    className={s.badge}
                    htmlAttributes={{
                      alt: `${name}-badge`,
                      loading,
                    }}
                    width={100}
                    height={100}
                  />
                  <div className={s.cameraContent}>
                    <Imgix
                      src={image}
                      {...imgParams}
                      htmlAttributes={{
                        alt: name,
                        class: s.cameraImage,
                        loading,
                      }}
                    />
                    <div className="content">
                      <H4>{name}</H4>
                      <Button
                        cypressId={`${name} link`}
                        isUnderlined
                        href={link}
                        style="text"
                        color="purple"
                        className="justify-center"
                      >
                        Learn More
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={s.wrapperEufyPartnersMobile}>
          <div className={s.copyWrapper}>
            <h3 className="text-h1" style={{ margin: '15px 0 25px' }}>
              Powerful protection from every angle.
            </h3>
            {filteredCameras.map((camera) => {
              const { name, description, badge, image, link } = camera;
              return (
                <div key={`${badge}-mobile`} className={s.itemWrapper}>
                  <div
                    className={
                      !!exclude.length
                        ? s.cameraWrapperExclude
                        : s.cameraWrapper
                    }
                  >
                    <Imgix
                      src={badge}
                      className={s.badge}
                      htmlAttributes={{
                        alt: `${name}-badge`,
                        loading,
                      }}
                      width={100}
                      height={100}
                    />
                    <Imgix
                      src={image}
                      width={234}
                      className={s.cameraImage}
                      htmlAttributes={{
                        alt: name,
                        style: { marginTop: 50 },
                        loading,
                      }}
                    />
                    <p className="text-h4">{name}</p>
                    <Button
                      cypressId={`${name} link learn more`}
                      isUnderlined
                      href={link}
                      style="text"
                      color="purple"
                    >
                      Learn More
                    </Button>
                  </div>
                  <div className={s.cameraRow}>
                    <b className="text-base">{name}</b>
                    <p className="text-base">{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={s.buttonWrapper}>
          <Button
            cypressId="eufy-partners-cta"
            href={ctaLink}
            size="large"
            style="container"
            color="purple"
          >
            See What It Costs
          </Button>
        </div>
      </div>
    </>
  );
};

export default EufyPartners;
